/**
 * Generates auto scaling css based on parent based on two sets of points.
 */
const scale = (parentSource, parentDest, childSource, childDest, sign, f) => {
  let factor = (childSource - childDest) / (parentSource - parentDest)
  let jump = -(parentSource * factor - childSource)
  if (f) return { factor, jump }
  return `calc(${Math.round(factor * 1000) / 10}${sign ? sign : "%"} ${
    jump < 0 ? "-" : "+"
  } ${Math.abs(Math.round(jump))}px)`
}

export default scale

/**
 * Generates auto scaling css for centering auto scaled objects.
 */
export const center = (pS, pD, cS, cD, s) => {
  var scObj = scale(pS, pD, cS, cD, null, true)
  var factor = Math.round((1 - scObj.factor) / 2 * 1000) / 10
  var jump = -(scObj.jump / 2)
  return `calc(${factor}${s ? s : "%"} ${jump < 0 ? "-" : "+"} ${Math.abs(
    Math.round(jump)
  )}px)`
}

export const scaleInverse = (pS, pD, cS, cD, sign) => {
  var scObj = scale(pS, pD, cS, cD, null, true)
  var factor = 100 - Math.round(scObj.factor * 1000) / 10
  var jump = Math.round(scObj.jump) * -1
  return `calc(${factor}${sign ? sign : "%"} ${jump < 0 ? "-" : "+"} ${Math.abs(
    jump
  )}px)`
}



// WEBPACK FOOTER //
// ./src/helper/scaling.js